/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 오늘의 홍보 학교 리스트
 * 버전 : 1.0
 * 파일명 : TodaysPromotionList.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-04
 * ================================================================
 */

import React from 'react'
import { Box, Typography } from '@mui/material'
import { getDateDifference, getDayOfWeek } from 'src/utils/DateUtils'
import styled from 'styled-components'

import e2 from "src/assets/images/marker_Element_2.svg"
import e4 from "src/assets/images/marker_Element_4.svg"
import Etc from "src/assets/images/marker_Element_Etc.svg"
import normal from "src/assets/images/marker_Element_normal.svg"
import specialize from "src/assets/images/marker_Element_specialize.svg"
import purpose from "src/assets/images/marker_Element_purpose.svg"
import self from "src/assets/images/marker_Element_self.svg"
import WatchIcon from '@mui/icons-material/WatchLater';
import StarIcon from '@mui/icons-material/Star';
import { usePromoresultStore } from 'src/stores/PromoStore'
import { PromoResultType } from 'src/pages/PromoResultPage'
import { BottomSheetType } from 'src/types/SchoolType'

interface BadgeIconProps {
  color: string;
}

const BadgeIcon = styled.div<BadgeIconProps>`
  border-radius: 100%;
  background-color: ${({ color }) => color};
  min-width: 30px;
  min-height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: auto;
`;

// 학교 항목 스타일링
const SchoolItem = styled.div<{ $isLast?: boolean }>`
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: ${({ $isLast }) => ($isLast ? 'none' : '1px solid #d3d3d3')};
`;

const BoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 9px;
`;

const UpperBoxTagBox = styled.div`
  align-self: flex-start;

  color: #1E9468; 
  padding: 3px 7px;
  border: 1px solid #1E9468;
  border-radius: 3px;
  font-size: 12px;
  background-color:#FFFFFF;
  white-space: nowrap;
  height: auto;
`

export type BottomSheetTypeExtand = BottomSheetType & {

}

interface Props{
    results: BottomSheetTypeExtand
    setTab? : React.Dispatch<React.SetStateAction<PromoResultType>>;
    isLast : boolean
}

const TodaysPromotionList = ({results, setTab, isLast}:Props) => {
    const setField = usePromoresultStore((state)=>state.setField)
    
    let color = "#F57749"
        let visited_At = '방문 기록 없음'
        if (results.visited_at){
            const datediff = getDateDifference(results.visited_at)
            if (datediff <= 180) { color = "#57C0AA";} 
            else if (datediff <= 365) { color = "#5CA8E4";} 
            else if (datediff <= 730) { color = "#F5BE49";}
            else if (datediff >= 730) { color = "#F57749";}
            visited_At = `${results.visited_at}(${getDayOfWeek(results.visited_at)})`;
        }
        let iconic = '';
        let parseType = ''
        let name = ''
        // 대학/전문대학 조건
        if (results.school_class === '전문대학' || results.school_class === '대학교') {
            // ✅ university or college
            name = results.school_name
            switch (results.school_type) {
              case '대학교':
                iconic = e4;
                break;
              case '사이버대학(대학)':
                iconic = e4;
                break;
              case '전문대학':
                iconic = e2;
                break;
              case '기능대학':
                iconic = e2;
                break;
              case '사이버대학(전문)':
                iconic = e2;
                break;
            }
        }
        else if (results.school_class ==='기타'){
          name = results.school_name
          iconic = Etc
        }
        // 고등학교 타입 조건
        else {
            // ✅ highschool
            name = results.school_name
            switch (results.school_type) {
                case '일반고등학교':
                iconic = normal;
                break;
                case '특성화고등학교':
                iconic = specialize;
                parseType = '특성화고'
                break;
                case '특수목적고등학교':
                iconic = purpose;
                parseType = '특목고'
                break;
                case '자율고등학교':
                iconic = self;
                parseType = '자율고'
                break;
            }
        }

    const handleDetail = ()=>{
        setField('current_promotion',results)
        setTab?.('detail')
    }
  return (
    <SchoolItem onClick={()=>handleDetail()} $isLast={isLast}>
            <BadgeIcon color={color}>
                <img src={iconic} alt="학교 아이콘" style={{width:'15px',height:'15px'}}/>
            </BadgeIcon>
            <BoxContainer style={{width:'100%'}}>
                <Box display="flex" alignItems="center" sx={{ marginBottom: "10px", gap:'8px'}}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize:'16px'}}>
                    {name}
                    </Typography>
                    {parseType &&
                    <UpperBoxTagBox>
                      {parseType}
                    </UpperBoxTagBox>
                    }
                </Box>
                <Typography variant="body2" display="flex" alignItems="center" sx={{opacity:0.5}}>
                    <WatchIcon fontSize="small" sx={{ color: 'gray', marginRight: 1 }} />
                    방문일자 | {visited_At}
                </Typography>
                <Typography variant="body2" display="flex" alignItems="center"sx={{opacity:0.5}}>
                    <StarIcon fontSize="small" sx={{ color: 'gray', marginRight: 1 }} />
                    관심표명자 | {results.interested_cnt}명
                </Typography>
            </BoxContainer>
    </SchoolItem>
  )
}

export default TodaysPromotionList